"use client";

import { useState, useEffect } from "react";
import ClothingCard from "./ClothingCard";

const styles = {
  scrollbarHide: {
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
};

const ClothingListing = ({
  clothingItems,
  initialImage,
  imgClick,
  isDouble = true,
  onItemClick,
}) => {
  // State to store screen height
  const [screenHeight, setScreenHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : 0
  );

  // Update screen height on resize
  useEffect(() => {
    const handleResize = () => setScreenHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Function to handle item click
  const handleItemClick = (item) => {
    if (onItemClick) {
      onItemClick({
        ...item,
        category: "Apparels",
        images: item.images || [item.image],
      });
    }
  };

  if (!isDouble) {
    // Single horizontal row - keep as is
    return (
      <div className="space-y-6 w-full">
        <div
          className="flex gap-4 overflow-x-auto scrollbar-hide p-2"
          style={{
            overflowX: "auto",
            overflowY: "hidden",
            WebkitOverflowScrolling: "touch",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          <img
            className="w-[244px] rounded-xl bg-white shadow-sm border cursor-pointer hover:shadow-md transition-shadow h-[280px]"
            onClick={imgClick}
            src={initialImage}
          />
          {clothingItems.map((item, index) => (
            <ClothingCard
              key={index}
              {...item}
              onClick={() => handleItemClick(item)}
            />
          ))}
        </div>
      </div>
    );
  } else {
    // Vertically scrolling grid format
    return (
      <div className="w-full h-[80vh]">
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 overflow-y-auto p-2"
          style={{
            height: "100%",
            scrollbarWidth: "none" /* Firefox */,
            msOverflowStyle: "none" /* IE and Edge */,
            WebkitOverflowScrolling: "touch",
          }}
        >
          <img
            className="w-[244px] rounded-xl bg-white shadow-sm border cursor-pointer hover:shadow-md transition-shadow h-[280px]"
            onClick={imgClick}
            src={initialImage}
          />
          {clothingItems.map((item, index) => (
            <ClothingCard
              key={index}
              {...item}
              onClick={() => handleItemClick(item)}
            />
          ))}
        </div>
      </div>
    );
  }
};

export default ClothingListing;
